import React from "react";
import "./dashboard-sidebar.scss";
import { NavLink } from "react-router-dom";

const DashboardSidebar = ({ isOpen }) => {
  return (
    <div className={`dashboard-sidebar ${isOpen ? "open" : "closed"}`}>
      <nav className="sidebar-nav">
        <ul className="main-nav">
          <li>
            <NavLink
              to="/user-information"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <img src="/images/icons/user-info.svg" alt="icon" /> User
              Information
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/order-management"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <img src="/images/icons/order-manage.svg" alt="icon" /> Order
              Management
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/pricing-management"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <img src="/images/icons/pricing-manage.svg" alt="icon" /> Pricing
              Management
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/article-management"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <img src="/images/icons/article-management.svg" alt="icon" />{" "}
              Article Management
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/activation-steps"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <img src="/images/icons/article-management.svg" alt="icon" />{" "}
              Activation Steps
            </NavLink>
          </li>
          {/* <li>
            <NavLink
              to="/deals-management"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <img src="/images/icons/deals-manage.svg" alt="icon" /> Deals
              Management
            </NavLink>
          </li> */}
          <li>
            <NavLink
              to="/merchant-management"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <img src="/images/icons/merchant-management.svg" alt="icon" />{" "}
              Merchant Management
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/commission-configuration"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <img src="/images/icons/commission.svg" alt="icon" /> Commission
              Management
            </NavLink>
          </li>
        </ul>

        <ul className="bottom-nav">
          <li>
            <NavLink
              to="/user-access-management"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <img src="/images/icons/user-manage.svg" alt="icon" /> User Access
              Management
            </NavLink>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default DashboardSidebar;
